import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import EzNotFound from "../../../common/EzNotFound";
import EzTable from "../../../common/EzTable";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;

const InvoicePayment = (props) => {
  const {
    tableData,
    paginationInfo,
    fetchInvoicePaymentLists,
    screenPermissions,
    navigateToInvoicesScreen,
    isPageLevelError,
    isLoading
  } = props;
  const [areFiltersVisible, toggleFilterState] = useState(false);

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative">
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div className="ml-3">
              <h4>Invoice Payments</h4>
            </div>
            {/* <Button
             label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
             icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
             className={`p-button-text p-button-secondary`}
             onClick={() => {
               toggleFilterState(!areFiltersVisible);
             }}
           /> */}
          </div>
          <Button
            tooltip={"Back to Invoices list"}
            tooltipOptions={{ position: "left" }}
            label={"Back to Invoices"}
            // icon={"pi pi-arrow-left"}
            className={`p-button `}
            style={{ borderRadius: "10px" }}
            onClick={navigateToInvoicesScreen}
          />
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderInvoicePaymentRecords = () =>
    tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderInvoicePaymentRecords() && !shouldRenderFullPageError();

  const filters = {
    global: { value: null },
    customer_name: { filterKey: "customer_name", value: null },
    invoice_no: { filterKey: "invoice_no", value: null },
    invoice_date: { filterKey: "invoice_date", value: null },
    invoice_due_date: { filterKey: "invoice_due_date", value: null },
    payment_mode: { filterKey: "payment_mode", value: null },
    payment_date: { filterKey: "payment_date", value: null },
    amount_paid: { filterKey: "amount_paid", value: null },
  };

  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    loadLazyData: fetchInvoicePaymentLists,
    value: tableData?.rows,
    emptyMessage: "No Invoice Payments found.",
    filters,
    loading: isLoading,
    showMoreActions: false,
  };
  return (
    <>
      <div className="paddingbox">
        <div className="containerbox">
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderInvoicePaymentRecords() && (
              <Row>
                <Col md={12}>
                  <EzTable {...tableProps} />
                </Col>
              </Row>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No smart buy records to show"}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default InvoicePayment;
